import axios from 'axios';

export default class NewsArchive {
    constructor() {

        this.loadMoreBtn = document.querySelector('.js-load-more-posts');

        this.endpoint = '/wp-json/fabric/v1/posts/0/';

        // If on a category archive use term_id in endpoint
        var id, matches = document.body.className.match(/(^|\s)category-(\d+)(\s|$)/);
        if (matches) {
            id = matches[2];
            this.endpoint = `/wp-json/fabric/v1/posts/${id}/`;
        }

        this.nextPage = 2;

        if(this.loadMoreBtn){
            this.bindEvents();
        }

    }

    bindEvents () {
        
        this.loadMoreBtn.addEventListener('click', e => {

            this.disableButton();         

            if (this.nextPage) {

                axios.get(`${this.endpoint + 'page/' + this.nextPage }`)
                .then( response => {
                    
                    if (response.data) {
                        this.renderCards(response.data);
                    }

                    if (!response.data.next_page) {
                        this.hideButton();
                    }

                })
                .catch( error => {
                    this.hideButton();
                })
                .then( () => {
                  // always executed
                });
                
            }

        });

    }

    renderCards (result) {
        let elems = [];
        for (let index = 0; index < result.posts.length; index++) {

            const element = result.posts[index];
  
            const $item = `
                <div class="w-full lg:w-1/3 px-2 xl:px-4 mb-11 xl:mb-16">
                    <div class="bg-grey-100 h-full">
                        <div>
                            ${element.thumbnail.url && 
                                `<a href="${ element.url }"><img
                                    class="w-full"
                                    src="${ element.thumbnail.url }"
                                    alt="${ element.thumbnail.alt }"
                                ></a>`
                            }
                        </div>
                        <div class="pt-4.5 pb-6 px-6">
                            <div class="flex mb-2">
                                ${ element.post_category.name != 'Uncategorised' &&
                                `<a class="text-black text-sm font-light bg-gold-400 rounded-sm px-1.5 mr-4" href="/news/category/${ element.post_category.slug }">${ element.post_category.name }</a>`
                                }
                                <div class="text-black text-sm font-light">${ element.post_date }</div>
                            </div>
                            <h3 class="text-xl lg:text-2xl font-light text-blue-700 mb-6"><a href="${ element.url }" alt="${ element.title }">
                                ${ element.title }
                            </a></h3>
                            <a href="${ element.url }" class="btn btn--blue">
                                <span>Continue reading</span>
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M-8.7738e-05 1.41L4.94464 6L-8.7738e-05 10.59L1.5222 12L8 6L1.5222 0L-8.7738e-05 1.41Z" fill="currentColor"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            `;
            elems.push($item);
        }               
        
        document.querySelector('.js-card-area').innerHTML += elems.join("");

        this.enableButton();

        this.nextPage = result.next_page;
    }

    enableButton () {
        this.loadMoreBtn.disabled = false;
    }

    disableButton () {
        this.loadMoreBtn.disabled = true;
    }

    hideButton () {
        this.loadMoreBtn.style.display = 'none';
    }
    
}

new NewsArchive;
